import { render, staticRenderFns } from "./FightResult.vue?vue&type=template&id=19e55c18&"
import script from "./FightResult.vue?vue&type=script&lang=js&"
export * from "./FightResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports